export const AtlassianDocumentationLogoInverse = () => (
  <svg
    width="608"
    height="48"
    viewBox="0 0 608 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_815_2131)">
      <path
        d="M10.3 19.9001C9.8 19.3001 9 19.4001 8.6 20.1001L0.0999985 37.1001C-0.200001 37.8001 0.299999 38.6001 0.999999 38.6001H12.8C13.2 38.6001 13.5 38.4001 13.7 38.0001C16.3 32.7001 14.7 24.7001 10.3 19.9001Z"
        fill="url(#paint0_linear_815_2131)"
      />
      <path
        d="M16.5 4.5001C11.8 12.0001 12.1 20.3001 15.2 26.6001C18.3 32.9001 20.7 37.6001 20.9 38.0001C21.1 38.4001 21.4 38.6001 21.8 38.6001H33.6C34.4 38.6001 34.8 37.8001 34.5 37.1001C34.5 37.1001 18.6 5.3001 18.2 4.5001C17.9 3.8001 16.9 3.8001 16.5 4.5001Z"
        fill="white"
      />
      <path
        d="M155 18.1001C155 22.3001 156.9 25.6001 164.6 27.1001C169.1 28.1001 170.1 28.8001 170.1 30.3001C170.1 31.8001 169.1 32.7001 165.9 32.7001C162.2 32.7001 157.8 31.4001 154.9 29.7001V36.5001C157.2 37.6001 160.2 38.9001 165.9 38.9001C173.9 38.9001 177 35.3001 177 30.1001M177 30.2001C177 25.2001 174.4 22.9001 166.9 21.3001C162.8 20.4001 161.8 19.5001 161.8 18.2001C161.8 16.6001 163.3 15.9001 166 15.9001C169.3 15.9001 172.5 16.9001 175.6 18.3001V11.8001C173.4 10.7001 170.1 9.90015 166.2 9.90015C158.8 9.90015 155 13.1001 155 18.3001"
        fill="white"
      />
      <path
        d="M257.4 10.1001V38.6001H263.5V16.9001L266 22.6001L274.6 38.6001H282.2V10.1001H276.2V28.5001L273.9 23.1001L267 10.1001H257.4Z"
        fill="white"
      />
      <path d="M218.8 10.1001H212.2V38.6001H218.8V10.1001Z" fill="white" />
      <path
        d="M204.6 30.1C204.6 25.1 202 22.8 194.5 21.2C190.4 20.3 189.4 19.4 189.4 18.1C189.4 16.5 190.9 15.8 193.6 15.8C196.9 15.8 200.1 16.8 203.2 18.2V11.7C201 10.6 197.7 9.80005 193.8 9.80005C186.4 9.80005 182.6 13 182.6 18.2C182.6 22.4 184.5 25.7001 192.2 27.2001C196.7 28.2001 197.7 28.9 197.7 30.4C197.7 31.9 196.7 32.8 193.5 32.8C189.8 32.8 185.4 31.5 182.5 29.8V36.6C184.8 37.7 187.8 39 193.5 39C201.4 39 204.6 35.4 204.6 30.1Z"
        fill="white"
      />
      <path
        d="M103.6 10.1001V38.6001H117.2L119.3 32.4001H110.2V10.1001H103.6Z"
        fill="white"
      />
      <path
        d="M76.7 10.1001V16.2001H84V38.6001H90.7V16.2001H98.6V10.1001H76.7Z"
        fill="white"
      />
      <path
        d="M67 10.1001H58.3L48.4 38.6001H56L57.4 33.8001C59.1 34.3001 60.9 34.6001 62.7 34.6001C64.5 34.6001 66.3 34.3001 68 33.8001L69.4 38.6001H77C76.9 38.6001 67 10.1001 67 10.1001ZM62.6 28.6001C61.3 28.6001 60.1 28.4001 59 28.1001L62.6 15.7001L66.2 28.1001C65.1 28.4001 63.9 28.6001 62.6 28.6001Z"
        fill="white"
      />
      <path
        d="M140.7 10.1001H132L122 38.6001H129.6L131 33.8001C132.7 34.3001 134.5 34.6001 136.3 34.6001C138.1 34.6001 139.9 34.3001 141.6 33.8001L143 38.6001H150.6L140.7 10.1001ZM136.3 28.6001C135 28.6001 133.8 28.4001 132.7 28.1001L136.3 15.7001L139.9 28.1001C138.8 28.4001 137.6 28.6001 136.3 28.6001Z"
        fill="white"
      />
      <path
        d="M242.7 10.1001H234L224.1 38.6001H231.7L233.1 33.8001C234.8 34.3001 236.6 34.6001 238.4 34.6001C240.2 34.6001 242 34.3001 243.7 33.8001L245.1 38.6001H252.7L242.7 10.1001ZM238.4 28.6001C237.1 28.6001 235.9 28.4001 234.8 28.1001L238.4 15.7001L242 28.1001C240.9 28.4001 239.6 28.6001 238.4 28.6001Z"
        fill="white"
      />
      <path
        d="M300.1 8H311.4C321.3 8 326.1 14.2 326.1 23.4C326.1 32.7 321.3 38.6 311.4 38.6H300.1V8ZM304.3 12V34.6H311.4C318.4 34.6 321.9 30.9 321.9 23.5C321.9 16.1 318.6 12 311.2 12H304.3Z"
        fill="white"
      />
      <path
        d="M329.5 26.8999C329.5 19.8999 333.6 14.8999 340.6 14.8999C347.5 14.8999 351.6 19.9999 351.6 26.8999C351.6 33.7999 347.6 38.9999 340.6 38.9999C333.6 38.9999 329.5 33.7999 329.5 26.8999ZM333.4 26.8999C333.4 31.2999 335.6 35.2999 340.6 35.2999C345.5 35.2999 347.7 31.2999 347.7 26.8999C347.7 22.4999 345.6 18.5999 340.6 18.5999C335.6 18.4999 333.4 22.4999 333.4 26.8999Z"
        fill="white"
      />
      <path
        d="M372.7 37.8999C371.3 38.5999 369.2 38.9999 367 38.9999C358.7 38.9999 354.9 33.9999 354.9 26.8999C354.9 19.8999 358.8 14.8999 367 14.8999C369.1 14.8999 370.7 15.1999 372.5 15.9999V19.6999C371 18.9999 369.4 18.5999 367.2 18.5999C361.2 18.5999 358.7 22.3999 358.7 26.8999C358.7 31.3999 361.2 35.1999 367.3 35.1999C369.7 35.1999 371.2 34.8999 372.6 34.3999V37.8999H372.7Z"
        fill="white"
      />
      <path
        d="M376.8 15.3H380.8V29.3C380.8 33.5 382.5 35.3 386.3 35.3C390 35.3 392.6 32.8 392.6 28.1V15.3H396.6V38.6H392.6V34.8C391.1 37.5 388.4 39.1 385.2 39.1C379.8 39.1 376.8 35.4 376.8 29V15.3Z"
        fill="white"
      />
      <path
        d="M422.3 38.5H418.3V24.5C418.3 20.3 416.6 18.5 412.8 18.5C409.1 18.5 406.5 21 406.5 25.7V38.6H402.5V15.3H406.5V19.1C408 16.4 410.7 14.8 413.9 14.8C417.9 14.8 420.6 16.8 421.7 20.5C423 16.9 426.1 14.8 430 14.8C435.2 14.8 438.1 18.3 438.1 24.9V38.5H434.1V25.6C434.1 20.8 432.4 18.4 428.6 18.4C424.9 18.4 422.3 20.9 422.3 25.6V38.5Z"
        fill="white"
      />
      <path
        d="M454.8 38.9999C446.1 38.9999 442.3 33.9999 442.3 26.8999C442.3 19.8999 446.2 14.8999 453.3 14.8999C460.5 14.8999 463.3 19.8999 463.3 26.8999V28.6999H446.3C446.9 32.6999 449.4 35.1999 454.9 35.1999C457.6 35.1999 459.9 34.6999 462 33.8999V37.5999C460.1 38.5999 457.2 38.9999 454.8 38.9999ZM446.3 25.1999H459.3C459.1 20.8999 457.1 18.3999 453.1 18.3999C448.9 18.3999 446.7 21.1999 446.3 25.1999Z"
        fill="white"
      />
      <path
        d="M487.9 38.5H483.9V24.5C483.9 20.3 482.2 18.5 478.4 18.5C474.7 18.5 472.1 21 472.1 25.7V38.6H468.1V15.3H472.1V19.1C473.6 16.4 476.3 14.8 479.5 14.8C484.8 14.8 487.9 18.5 487.9 24.9V38.5Z"
        fill="white"
      />
      <path
        d="M502.7 34.8001C503.6 34.8001 504.5 34.6001 505.2 34.5001V38.4001C504.5 38.6001 503.7 38.8001 502.5 38.8001C497.5 38.8001 495.1 35.9001 495.1 31.5001V19.0001H491.3V15.3001H495.1V10.4001H499V15.3001H505.2V19.0001H499V31.3001C499 33.4001 500.2 34.8001 502.7 34.8001Z"
        fill="white"
      />
      <path
        d="M525.1 34.4001C523.6 37.5001 520.8 39.1001 517.2 39.1001C511 39.1001 507.9 33.8001 507.9 27.0001C507.9 20.4001 511.2 14.9001 517.7 14.9001C521.1 14.9001 523.7 16.4001 525.1 19.5001V15.4001H529.1V38.7001H525.1V34.4001ZM518.3 35.3001C521.9 35.3001 525.1 33.0001 525.1 27.9001V26.0001C525.1 20.8001 522.2 18.6001 518.8 18.6001C514.3 18.6001 512 21.6001 512 27.0001C512 32.5001 514.2 35.3001 518.3 35.3001Z"
        fill="white"
      />
      <path
        d="M544.4 34.8001C545.3 34.8001 546.2 34.6001 546.9 34.5001V38.4001C546.2 38.6001 545.4 38.8001 544.2 38.8001C539.2 38.8001 536.8 35.9001 536.8 31.5001V19.0001H533V15.3001H536.8V10.4001H540.7V15.3001H546.9V19.0001H540.7V31.3001C540.7 33.4001 541.9 34.8001 544.4 34.8001Z"
        fill="white"
      />
      <path
        d="M554.1 6.40015C555.7 6.40015 556.9 7.40015 556.9 9.20015C556.9 11.0001 555.7 12.0001 554.1 12.0001C552.5 12.0001 551.3 11.0001 551.3 9.20015C551.3 7.40015 552.4 6.40015 554.1 6.40015ZM552 15.3001H556V38.6001H552V15.3001Z"
        fill="white"
      />
      <path
        d="M560.7 26.9001C560.7 19.9001 564.8 14.9001 571.8 14.9001C578.7 14.9001 582.8 20.0001 582.8 26.9001C582.8 33.8001 578.8 39.0001 571.8 39.0001C564.8 39.0001 560.7 33.8001 560.7 26.9001ZM564.6 26.9001C564.6 31.3001 566.8 35.3001 571.8 35.3001C576.7 35.3001 578.9 31.3001 578.9 26.9001C578.9 22.5001 576.8 18.6001 571.8 18.6001C566.8 18.5001 564.6 22.5001 564.6 26.9001Z"
        fill="white"
      />
      <path
        d="M607.2 38.5H603.2V24.5C603.2 20.3 601.5 18.5 597.7 18.5C594 18.5 591.4 21 591.4 25.7V38.6H587.4V15.3H591.4V19.1C592.9 16.4 595.6 14.8 598.8 14.8C604.1 14.8 607.2 18.5 607.2 24.9V38.5Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_815_2131"
        x1="14.9161"
        y1="22.5565"
        x2="5.9611"
        y2="38.0665"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="0.923" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_815_2131">
        <rect width="608" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
